import { connect } from "react-redux";

import {
  selectMaterialById,
  addMaterial
} from "~/store/ducks/application/materials/materials";

import { selectIsGreaterThanMedium } from "~/store/ducks/application/browser";

import { switchModal } from "~/store/ducks/domain/ui/modal";

import NewMaterialModal from "./NewMaterialModal";

const mapStateToProps = (state, ownProps) => ({
  material: selectMaterialById(ownProps.id)(state),
  isGreaterThanMedium: selectIsGreaterThanMedium(state)
});

const mapDispatchToProps = {
  switchModal,
  addMaterial
};

export default connect(mapStateToProps, mapDispatchToProps)(NewMaterialModal);
